import React from 'react';
import { Empty, Icon } from 'antd';

const NotFoundImage = <Icon type="close-circle" style={{ fontSize: '72px' }} />;
const NotFoundDescription = <span style={{ fontSize: '48px' }}>Page Not Found</span>;

const FourOhFour = () => <Empty description={NotFoundDescription} image={NotFoundImage} />;

export { FourOhFour };
